import { useFilterLabel } from "../../hooks/useFilterLabel";

import React, { useState, useEffect, useRef, useReducer } from "react";
import { useAuthDataContext } from "../../containers/AuthDataProvider";
import PersistentDrawerLeft from "../../components/part/PersistentDrawerLeft";
import CreateArticleFab from "../../components/part/CreateArticleFab";
import ArticleProvider from "../part/ArticleProvider";
import ArticleList from "../../components/part/ArticleList";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import "../part/CKEditor_custom.scss";

export default function ArticlesBySpecifiedUser(props) {
  // console.log("start ArticlesBySpecifiedUser");
  const user = useAuthDataContext();

  const [isLoading, setIsLoading] = useState(true);

  const ARTICLE_CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
  const ARTICLE_UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
  const ARTICLE_DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
  const ARTICLE_INITIAL_QUERY = "INITIAL_QUERY";
  const ARTICLE_ADDITIONAL_QUERY = "ADDITIONAL_QUERY";

  const articleReducer = (state, action) => {
    switch (action.type) {
      case ARTICLE_INITIAL_QUERY:
        setIsLoading(false);
        return action.articles;
      case ARTICLE_ADDITIONAL_QUERY:
        setIsLoading(false);
        return [...state, ...action.articles];
      case ARTICLE_CREATE_SUBSCRIPTION:
        return [action.article, ...state];
      case ARTICLE_UPDATE_SUBSCRIPTION:
        var pos = state.map((x) => x.id).indexOf(action.article.id);
        state.splice(pos, 1, action.article);
        return [...state];
      case ARTICLE_DELETE_SUBSCRIPTION:
        pos = state.map((x) => x.id).indexOf(action.article.id);
        state.splice(pos, 1);
        return [...state];
      default:
        return state;
    }
  };

  const [articles, dispatchArticle] = useReducer(articleReducer, []);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("articles"));
    if (storageVar) {
      dispatchArticle(storageVar);
    }
  }, []);
  useEffect(() => {
    sessionStorage.setItem("articles", JSON.stringify(articles));
  }, [articles]);

  const [articlesNextToken, setArticlesNextToken] = useState(null);
  useEffect(() => {
    sessionStorage.setItem("articlesNextToken", JSON.stringify(articlesNextToken));
  }, [articlesNextToken]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("articlesNextToken"));
    if (storageVar) {
      setArticlesNextToken(storageVar);
    }
  }, []);

  const refArticleAttachmentProvider = useRef();

  const [articlesOffset, setArticlesOffset] = useState(null);
  useEffect(() => {
    sessionStorage.setItem("articlesOffset", JSON.stringify(articlesOffset));
  }, [articlesOffset]);
  useEffect(() => {
    const storageVar = JSON.parse(sessionStorage.getItem("articlesOffset"));
    if (storageVar) {
      setArticlesOffset(storageVar);
    }
  }, []);

  function scrollToPrevious() {
    window.scrollTo({
      top: sessionStorage.getItem("articlesOffset"),
    });
  }

  function putScrollSession() {
    let _offset =
      window.pageYOffset ||
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    // setArticlesOffset(_offset);
    // なぜかこれだと、useEffectのreturn時(unmount時)にセットできないので、下の行のように直接sessionStorageにセットした
    sessionStorage.setItem("articlesOffset", _offset);
  }

  const { filterLabelName, filterLabelColor, page, setPage, handleLabelFileter } = useFilterLabel();

  sessionStorage.setItem("prevPage", "/timeline");

  return (
    <React.Fragment>
      <PersistentDrawerLeft
        type="timeline"
        handleLabelFileter={handleLabelFileter}
        filterLabelName={filterLabelName}
        filterLabelColor={filterLabelColor}
        setIsLoading={setIsLoading}
      >
        <ArticleProvider
          ref={refArticleAttachmentProvider}
          user={user}
          articles={articles}
          dispatchArticle={dispatchArticle}
          articlesNextToken={articlesNextToken}
          setArticlesNextToken={setArticlesNextToken}
          putScrollSession={putScrollSession}
          scrollToPrevious={scrollToPrevious}
          setIsLoading={setIsLoading}
        ></ArticleProvider>

        {!!refArticleAttachmentProvider.current && (
          <ArticleList
            isLoading={isLoading}
            articles={articles}
            filterLabelName={filterLabelName}
            getAdditionalArticles={refArticleAttachmentProvider.current.getAdditionalArticles}
            articlesNextToken={articlesNextToken}
            scrollToPrevious={scrollToPrevious}
            page={page}
            setPage={setPage}
          />
        )}
        {!refArticleAttachmentProvider.current && (
          <Container fixed>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <br />{" "}
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <CircularProgress color="secondary" />
            </Grid>
          </Container>
        )}
        <CreateArticleFab />
      </PersistentDrawerLeft>
    </React.Fragment>
  );
}
